import React, { useState, useEffect, useRef } from "react";
import Blink from "./Blink.js";
import "./Fading.css";
import { FaVolumeUp, FaVolumeMute } from 'react-icons/fa';

export default function Video(props) {
  const [isMuted, setIsMuted] = useState(true);
  const [showBlink, setShowBlink] = useState(false);

  const audioRef = useRef(null);
  const videoRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowBlink(true);
    }, 5000);

    let observer;
    if (videoRef.current) {
      observer = new IntersectionObserver(
        entries => {
          const [entry] = entries;
          if (entry.isIntersecting) {
            // Video is in view
          } else {
            // Video is not in view, mute it
            setIsMuted(true);
            videoRef.current.muted = true;
          }
        },
        {
          threshold: 0,
        }
      );
      
      observer.observe(videoRef.current);
    }

    return () => {
      clearTimeout(timer);
      if (observer) observer.disconnect();
    };
  }, []);

  const handleMute = () => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  const handleVideoPlay = () => {
    if (audioRef.current) {
      audioRef.current.play();
    }
  };

  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "black",
        height: "100vh",
        width: "100vw",
        //overflowX: "hidden",
        padding: props.isMobile? "1vh 1vw":"1vh 0vw"
      }}
    >
      <video
        ref={videoRef}
        preload="auto"
        loop={true}
        muted={true}
        defaultMuted
        autoPlay
        playsInline
        src={props.textVideo}
        style={{ 
          width: "100%", 
          height: props.isMobile?"auto":"100%", 
          objectFit: "cover" 
        }}
        onLoad={() => {
          this.player.seek(0);
        }}
        onPlay={handleVideoPlay}
      />
      <button 
        onClick={handleMute} 
        style={{ 
          position: 'absolute', 
          zIndex: 100, 
          bottom: props.isMobile? '150px':'20px', 
          right: props.isMobile? '5px':'30px',
          backgroundColor: 'transparent',
          border: 'none',
          fontSize: props.isMobile? '1.8rem':'2.8rem',
          color: 'white',
          cursor: 'pointer'
        }}>      
         {isMuted ? <FaVolumeMute /> : <FaVolumeUp />}
      </button>
    </div>
  );
}
